import Pikaday from 'pikaday'

const DATE_FORMAT = 'ddd D MMM YY'

const outwardDate = document.getElementById('_ctl0_MainContent_FerryBooking_txtOutDate')
const returnDate = document.getElementById('_ctl0_MainContent_FerryBooking_txtRtnDate')

if (outwardDate !== null) {
    const o = new Pikaday({
        field: outwardDate,
        minDate: new Date(),
        format: DATE_FORMAT,
        firstDay: 1,
    })
    console.log(o)
}


if (returnDate !== null) {
    const r = new Pikaday({
        field: returnDate,
        minDate: new Date(),
        format: DATE_FORMAT,
        firstDay: 1,
    })
    console.log(r)
}
